// extracted by mini-css-extract-plugin
module.exports = {"standard":"standardCard_standard__UsdfT","card":"standardCard_card__zMaMy"};